// shared/pdf/documents/CashBookDocument.jsx
import React from 'react';
import { Document, Page, View, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import PdfFilterLine from '../components/PdfFilterLine';
import PdfSummaryCards from '../components/PdfSummaryCards';
import { PdfTableHead, PdfTableRow } from '../components/PdfTable';
import { fmtINR, fmtDate } from '../pdfUtils';

const s = StyleSheet.create({
  page:    { fontFamily: 'NotoSans', paddingBottom: 60 },
  content: { marginHorizontal: 40, marginTop: 12 },
});

const COLS = [
  { label: 'Date',           flex: 0.9 },
  { label: 'Voucher No',     flex: 1.0 },
  { label: 'Payee / Member', flex: 1.2 },
  { label: 'Narration',      flex: 2.4 },
  { label: 'Dr (Rs.)',       flex: 1,   align: 'right' },
  { label: 'Cr (Rs.)',       flex: 1,   align: 'right' },
  { label: 'Balance (Rs.)',  flex: 1.1, align: 'right' },
];

export default function CashBookDocument({ data, theme: themeKey, orientation, sections, filters }) {
  const t = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  return (
    <Document>
      <Page size="A4" orientation={orientation || 'landscape'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && <PdfHeader derasar={data.derasar} reportTitle="Cash Book" theme={t} />}
        <View style={s.content}>
          {sections.filterLine && <PdfFilterLine filters={filters} theme={t} />}
          {sections.summaryCards && (
            <PdfSummaryCards theme={t} items={[
              { label: 'Opening Balance', value: fmtINR(data.openingBalance), color: t.body    },
              { label: 'Closing Balance', value: fmtINR(data.closingBalance), color: t.statusGreen },
            ]} />
          )}
          <PdfTableHead cols={COLS} theme={t} />
          {(data.rows || []).map((row, i) => (
            <PdfTableRow key={i} cols={COLS} index={i} theme={t}
              values={[fmtDate(row.date), row.voucherNo, row.payeeName || '—', row.narration || '—', row.debit ? fmtINR(row.debit) : '—', row.credit ? fmtINR(row.credit) : '—', fmtINR(row.balance)]}
            />
          ))}
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}



